export default __webpack_public_path__ + "static/media/Breastfeeding.e5c2656f.png";